import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Utils/axiosInstance";

export const fetchRecentlyViewed = createAsyncThunk(
  "recentlyViewed/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/recentlyView");
      return res.data.recentlyView || [];
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const addToRecentlyViewed = createAsyncThunk(
  "recentlyViewed/add",
  async ({ gameId }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/recentlyView/add", { gameId });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const recentlyViewedSlice = createSlice({
  name: "recentlyViewed",
  initialState: { 
    items: [], 
    loading: false, 
    error: null 
  },
  reducers: {
    setRecentlyViewedLocal: (state, action) => {
      state.items = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecentlyViewed.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRecentlyViewed.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchRecentlyViewed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setRecentlyViewedLocal } = recentlyViewedSlice.actions;
export default recentlyViewedSlice.reducer;
